import { render, staticRenderFns } from "./mainbusinessPage8.vue?vue&type=template&id=49f49d08&scoped=true&"
import script from "./mainbusinessPage8.vue?vue&type=script&lang=js&"
export * from "./mainbusinessPage8.vue?vue&type=script&lang=js&"
import style0 from "./mainbusinessPage8.vue?vue&type=style&index=0&id=49f49d08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f49d08",
  null
  
)

export default component.exports